import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import zhCN from '@/lang/zh-CN'
import enUS from '@/lang/en-US'


// 获取用户的浏览器语言
let lang = navigator.language || navigator.userLanguage;

if (lang !== 'zh-CN') {
  lang = 'en_US'
}
lang = lang.replace('_', '-')
window.localStorage.setItem('lang', lang)


console.log(3333, VueI18n)

const i18n = new VueI18n({
  locale: lang,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
